import axios from '@/store/axiosInstance';

const state = {
  allDates: [],
  loadedRange: null,
}

const getters = {
  getAllDates: (state) => state.allDates,
  getLoadedRange: (state) => state.loadedRange,
}

// Last requested range; keeps a late, stale response from overwriting newer data.
let latestRequest = null;

const actions = {
  fetchDatesForRange({ commit, state }, { from, to }) {
    const loaded = state.loadedRange;
    if (loaded && loaded.from <= from.getTime() && loaded.to >= to.getTime()) return;

    const key = `${from.getTime()}-${to.getTime()}`;
    latestRequest = key;

    axios.get("/termine/expanded", { params: { from: from.toISOString(), to: to.toISOString() } })
      .then(res => {
        if (latestRequest !== key) return;
        commit("setAllDates", res.data.docs);
        commit("setLoadedRange", { from: from.getTime(), to: to.getTime() });
      })
      .catch(err => console.error(err));
  },
}

const mutations = {
  setAllDates: (state, dates) => state.allDates = dates,
  setLoadedRange: (state, range) => state.loadedRange = range,
}

export default {
  state,
  getters,
  actions,
  mutations
}
